<dx-select-box #selectBox
    [dataSource]="days"
    [value]="selectedItem"
    displayExpr="name"
    valueExpr="id"
    [disabled]="loading"
    (selectedItemChange)="onSelectedItemChange($event)">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgDayRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
